import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-88">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl flex items-center justify-between" data-id="element-89">
        <div className="flex items-center gap-3" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/6pWJMAggcgSCbmH86h4GdK/Logo_Tu_Aura_Ok_Ok.png" alt="Tu Aura Simple Logo" className="h-10 w-10 md:h-12 md:w-12 object-contain" data-id="element-91" />
          <span className={`font-heading font-bold text-xl md:text-2xl tracking-wide ${isScrolled ? 'text-navy' : 'text-navy'}`} data-id="element-92">
            Tu Aura Simple
          </span>
        </div>

        <div className="hidden md:block" data-id="element-93">
          <Button variant="primary" size="sm" onClick={() => document.getElementById('cta-button')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} data-id="element-94">
            Comenzar Ahora
          </Button>
        </div>
      </div>
    </motion.nav>;
}